import api from './api';
import { DashboardStats, RecentActivity, DashboardData, DashboardFilters, RevenueStats, BusDashboardStats, BusRevenueStats } from '../interfaces/Dashboard';

export const dashboardService = {
  async getStats(): Promise<DashboardStats> {
    const response = await api.get('/read/dashboard/stats');
    return response.data;
  },

  async getRecentActivities(): Promise<RecentActivity[]> {
    const response = await api.get('/read/dashboard/activities');
    return response.data;
  },

  async getDashboardData(): Promise<DashboardData> {
    const [stats, activities] = await Promise.all([
      this.getStats(),
      this.getRecentActivities()
    ]);
    
    return {
      stats,
      recentActivities: activities
    };
  },

  async getRevenueWithFilters(filters: DashboardFilters): Promise<RevenueStats> {
    // Temporarily use the /range endpoint as a workaround for validation issues
    if (filters.startDate && filters.endDate) {
      return this.getRevenueByDateRange(filters.startDate, filters.endDate);
    }
    
    // Fallback to original endpoint if no date filters
    const params = new URLSearchParams();
    if (filters.startDate) params.append('startDate', filters.startDate);
    if (filters.endDate) params.append('endDate', filters.endDate);
    if (filters.status && filters.status !== 'all') params.append('status', filters.status);

    const response = await api.get(`/read/dashboard/revenue?${params.toString()}`);
    return response.data;
  },

  async getRevenueByDateRange(startDate: string, endDate: string): Promise<RevenueStats> {
    const response = await api.get(`/read/dashboard/revenue/range?startDate=${startDate}&endDate=${endDate}`);
    return response.data;
  },

  // ── Ônibus ────────────────────────────────────────────────────────────────

  async getBusStats(): Promise<BusDashboardStats> {
    const response = await api.get('/read/dashboard/bus-stats');
    return response.data;
  },

  async getBusRevenueByDateRange(startDate: string, endDate: string): Promise<BusRevenueStats> {
    const response = await api.get(`/read/dashboard/bus-revenue/range?startDate=${startDate}&endDate=${endDate}`);
    return response.data;
  },
};
